import { useEffect, useLayoutEffect } from 'react';

import { isClient } from 'utils/helpers';

export const useIsomorphicLayoutEffect = isClient()
	? useLayoutEffect
	: useEffect;
